import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M21 11H3a1 1 0 00-1 1c0 .6.5 1 1 1h18c.6 0 1-.4 1-1 0-.5-.4-1-1-1M3 6h18c.6 0 1-.4 1-1s-.4-1-1-1H3a1 1 0 00-1 1c0 .6.5 1 1 1M21 18H3a1 1 0 00-1 1c0 .6.5 1 1 1h18c.6 0 1-.4 1-1s-.4-1-1-1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol